<template>
  <btn
    type="submit"
    :variant="variant || 'primary'"
    v-bind="{
      ...$attrs,
      size,
    }"
    :disabled="busy || loading || disabled"
    :data-cy="dataCy"
    @click="$emit('click', $event)"
  >
    <slot></slot>
    <slot name="submitText">{{ submitTxt }}</slot>
  </btn>
</template>

<script>
  export default {
    name: 'SubmitBtn',

    data: () => ({
      busy: false,
    }),

    props: {
      submitText: {
        type: String,
        default: 'Submit',
      },
      loading: Boolean,
      variant: {
        type: String,
        default: 'primary',
      },
      disabled: Boolean,
      dataCy: String,
      size: {
        type: String,
        default: 'md',
      },
    },

    computed: {
      submitTxt() {
        return this.submitText ?? this.$t('cmrad.submit');
      },

      computedClass() {
        return this.$attrs.class ?? '' + ' position-relative';
      },
    },

    watch: {
      loading(v) {
        this.busy = v;
      },
    },
  };
</script>
